import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { exchangeLink } from "../api";
import { Brand } from "../components/brand";
import { ErrorBanner } from "../components/status";
import { storeSession } from "../session";

export function CoHostEntryPage() {
  const { linkId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  useEffect(() => {
    const secret = new URLSearchParams(window.location.hash.slice(1)).get("key");
    if (!linkId || !secret) {
      setError("Co-Host-Link ist unvollständig.");
      return;
    }
    void exchangeLink(linkId, secret)
      .then((response) => {
        storeSession({ roomId: response.roomId, token: response.token, role: "cohost" });
        navigate(`/control/${response.roomId}`, { replace: true });
      })
      .catch((exchangeError) => setError(exchangeError instanceof Error ? exchangeError.message : "Link ist ungültig."));
  }, [linkId, navigate]);
  return (
    <main className="shell">
      <Brand />
      <ErrorBanner message={error ?? "Co-Host-Zugang wird geprüft..."} />
    </main>
  );
}

